import { createAsyncActionType } from './index';

export const DASHBOARD_INFO_GET = createAsyncActionType(
  'dashboard',
  'DASHBOARD_INFO_GET'
);

export const EMPTY_COURSES_GET = createAsyncActionType(
  'dashboard',
  'EMPTY_COURSES_GET'
);

export const LAST_COURSES_GET = createAsyncActionType(
  'dashboard',
  'LAST_COURSES_GET'
);

export const COMPLETED_COURSES_GET = createAsyncActionType(
  'dashboard',
  'COMPLETED_COURSES_GET'
);
